// import React, { useState } from 'react';
// import '../css/Dashboard.css';

// const Sidebar = () => {
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   return (
//     <div className="sidebar">
//       {/* Search Bar with SVG Icon */}
//       <div className="search-bar">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="#808080" /* Icon color */
//           strokeWidth="2"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           className="search-icon"
//         >
//           <circle cx="11" cy="11" r="8"></circle>
//           <line x1="16" y1="16" x2="22" y2="22"></line>
//         </svg>
//         <input
//           type="text"
//           value={searchQuery}
//           onChange={handleSearchChange}
//           placeholder="Search..."
//           className="search-input"
//         />
//       </div>

//       <div className="title">All Projects</div>
//       <ul>
//         <li className="current">NEOM Green Hydrogen</li>
//         <li>NEOM Training</li>
//         {/* Add more projects as needed */}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Sidebar.css";

const Sidebar = () => {
  const [expandedSection, setExpandedSection] = useState(null);
    const navigate = useNavigate();

    const handleDirectoryClick = () => {
      toggleSection("directory"); // your existing toggle logic
      navigate("/search-directory"); // navigation to new page
    };

  const toggleSection = (section) => {
    setExpandedSection((prev) => (prev === section ? null : section));
  };

  return (
    <div className="sidebar">
      {/* dashboard */}
      <div
        className={`toggle-button ${
          expandedSection === "dashboard" ? "active" : ""
        }`}
        onClick={() => toggleSection("dashboard")}
      >
        <div className="text-box">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              border="1"
              fill="none"
              stroke="#181818"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 14 14"
            >
              <path d="M 4.33333 10.3333 H 9.66667 M 6.34513 0.842666 L 1.82359 4.35942 C 1.52135 4.5945 1.37022 4.71204 1.26135 4.85924 C 1.16491 4.98963 1.09307 5.13652 1.04935 5.2927 C 1 5.46901 1 5.66046 1 6.04337 V 10.8667 C 1 11.6134 1 11.9868 1.14532 12.272 C 1.27316 12.5229 1.47713 12.7268 1.72801 12.8547 C 2.01323 13 2.3866 13 3.13333 13 H 10.8667 C 11.6134 13 11.9868 13 12.272 12.8547 C 12.5229 12.7268 12.7268 12.5229 12.8547 12.272 C 13 11.9868 13 11.6134 13 10.8667 V 6.04337 C 13 5.66046 13 5.46901 12.9506 5.2927 C 12.9069 5.13652 12.8351 4.98963 12.7386 4.85924 C 12.6298 4.71204 12.4787 4.5945 12.1764 4.35942 L 7.65487 0.842666 C 7.42065 0.660497 7.30354 0.569413 7.17423 0.5344 C 7.06013 0.503507 6.93987 0.503507 6.82577 0.5344 C 6.69646 0.569413 6.57935 0.660497 6.34513 0.842666 Z" />
            </svg>
          </div>
          <div className="toggle-label">Dashboard</div>
        </div>
        <div>
          <svg
            className={`chevron ${expandedSection === "dashboard" ? "" : ""}`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
      {/* {expandedSection === "dashboard" && (
        <div className="sidebar-lists">
          <ul className="sidebar-sublist">
            <li>Assigned to me</li>
            <li>In progress</li>
            <li>Completed</li>
          </ul>
        </div>
      )} */}
      {/* Documents */}
      <div
        className={`toggle-button ${
          expandedSection === "documents" ? "active" : ""
        }`}
        onClick={() => toggleSection("documents")}
      >
        <div className="text-box">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              stroke="#181818"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 16 16"
            >
              <path d="M 14.6667 6.66659 V 9.99992 C 14.6667 13.3333 13.3334 14.6666 10 14.6666 H 6.00004 C 2.66671 14.6666 1.33337 13.3333 1.33337 9.99992 V 5.99992 C 1.33337 2.66659 2.66671 1.33325 6.00004 1.33325 H 9.33337" />
              <path d="M 14.6667 6.66658 H 12 C 10 6.66658 9.33337 5.99992 9.33337 3.99992 V 1.33325 L 14.6667 6.66658 Z" />
              <path d="M 4.66663 8.66675 H 8.66663" />
              <path d="M 4.66663 11.3333 H 7.33329" />
            </svg>
          </div>
          <div className="toggle-label">Documents</div>
        </div>
        <div>
          <svg
            className={`chevron ${
              expandedSection === "documents" ? "rotate" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
      {expandedSection === "documents" && (
        <div className="sidebar-lists">
          <ul className="sidebar-sublist">
            <li onClick={() => navigate("/documents")}>Document Register</li>
            <li>Drawings</li>
            <li>Temporary Files</li>
          </ul>
          <div className="section-title">My Organization's Searches</div>
          <ul className="sidebar-sublist">
            <li>IFC Drawings - BESS</li>
            <li>IFC Drawings - Solar...</li>
            <li>IFC Drawings - Wind...</li>
          </ul>
          <div className="section-title">Standard Searches</div>
          <ul className="sidebar-sublist">
            <li>Approved</li>
            <li>Issued for approval</li>
            <li>Drawings modified to...</li>
            <li>Temporary files uploa...</li>
          </ul>
        </div>
      )}

      {/* Mail */}
      <div
        className={`toggle-button ${
          expandedSection === "mail" ? "active" : ""
        }`}
        onClick={() => toggleSection("mail")}
      >
        <div className="text-box">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              stroke="#181818"
              stroke-meterlimit="10"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 16 16"
            >
              <path d="M 11.3334 13.6666 H 4.66671 C 2.66671 13.6666 1.33337 12.6666 1.33337 10.3333 V 5.66659 C 1.33337 3.33325 2.66671 2.33325 4.66671 2.33325 H 11.3334 C 13.3334 2.33325 14.6667 3.33325 14.6667 5.66659 V 10.3333 C 14.6667 12.6666 13.3334 13.6666 11.3334 13.6666 Z" />
              <path d="M 11.3333 6 L 9.24662 7.66667 C 8.55996 8.21333 7.43329 8.21333 6.74662 7.66667 L 4.66663 6" />
            </svg>
          </div>
          <div className="toggle-label">Mail</div>
        </div>
        <div>
          <svg
            className={`chevron ${expandedSection === "mail" ? "rotate" : ""}`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
      {expandedSection === "mail" && (
        <div className="sidebar-lists">
          <div className="section-title">Search</div>
          <ul className="sidebar-sublist">
            <li>All</li>
            <li>Inbox</li>
            <li>Sent</li>
            <li>Drafts</li>
          </ul>
          <div className="section-title">Cretae New</div>
          <ul className="sidebar-sublist">
            <li>Blank Mail</li>
          </ul>
          <div className="section-title">Actions</div>
          <ul className="sidebar-sublist">
            <li>Register Incoming Mail</li>
            <li>Mail Approval</li>
          </ul>
          <div className="section-title">Standard Searches</div>
          <ul className="sidebar-sublist">
            <li>My mail received today</li>
            <li>My mail sent today</li>
            <li>My Outstanding & Overdue 
            mail</li>
            <li>Org mail not Closed Out</li>
            <li>Org mail received in last 30
            days</li>
            <li>Org Outstanding & Overdue
            mail</li>
            <li>RFIs received reports</li>
          </ul>
        </div>
      )}

      {/* Workflows */}
      <div
        className={`toggle-button ${
          expandedSection === "workflows" ? "active" : ""
        }`}
        onClick={() => toggleSection("workflows")}
      >
        <div className="text-box">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              stroke="#181818"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 16 16"
            >
              <path d="M 13.3333 9.33341 C 14.0697 9.33341 14.6667 8.73646 14.6667 8.00008 C 14.6667 7.2637 14.0697 6.66675 13.3333 6.66675 C 12.597 6.66675 12 7.2637 12 8.00008 C 12 8.73646 12.597 9.33341 13.3333 9.33341 Z" />
              <path d="M 13.3333 3.99992 C 14.0697 3.99992 14.6667 3.40296 14.6667 2.66659 C 14.6667 1.93021 14.0697 1.33325 13.3333 1.33325 C 12.597 1.33325 12 1.93021 12 2.66659 C 12 3.40296 12.597 3.99992 13.3333 3.99992 Z" />
              <path d="M 13.3333 14.6667 C 14.0697 14.6667 14.6667 14.0697 14.6667 13.3333 C 14.6667 12.597 14.0697 12 13.3333 12 C 12.597 12 12 12.597 12 13.3333 C 12 14.0697 12.597 14.6667 13.3333 14.6667 Z" />
              <path d="M 2.66671 9.33341 C 3.40309 9.33341 4.00004 8.73646 4.00004 8.00008 C 4.00004 7.2637 3.40309 6.66675 2.66671 6.66675 C 1.93033 6.66675 1.33337 7.2637 1.33337 8.00008 C 1.33337 8.73646 1.93033 9.33341 2.66671 9.33341 Z" />
              <path d="M 4 8 H 12" />
              <path d="M 12 2.66675 H 9.33337 C 8.00004 2.66675 7.33337 3.33341 7.33337 4.66675 V 11.3334 C 7.33337 12.6667 8.00004 13.3334 9.33337 13.3334 H 12" />
            </svg>
          </div>
          <div className="toggle-label">Workflows</div>
        </div>
        <div>
          <svg
            className={`chevron ${
              expandedSection === "workflows" ? "rotate" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
      {expandedSection === "workflows" && (
        <div className="sidebar-lists">
          <div className="section-title">Actions</div>
          <ul className="sidebar-sublist">
            <li>Workflows</li>
            <li>Templates</li>
          </ul>
          <div className="section-title">Standard Searches</div>
          <ul className="sidebar-sublist">
            <li onClick={() => navigate("/workflows")}>Assigned to me</li>
            <li>Assigned to my organization</li>
            <li>Completed in the last 7 days</li>
            <li>Org mail not Closed Out</li>
            <li>Initiated by me</li>
            <li>Initiated by my organization</li>
            <li>Received in the last 7 days</li>
            <li>Received yesterday</li>
          </ul>
        </div>
      )}

      {/* Directory */}
      <div
        className={`toggle-button ${
          expandedSection === "directory" ? "active" : ""
        }`}
        onClick={handleDirectoryClick}
      >
        <div className="text-box">
          <div className="icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              stroke="#181818"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 16 16"
            >
              <path d="M 6.10634 7.24658 C 6.03967 7.23992 5.95967 7.23992 5.88634 7.24658 C 4.29967 7.19325 3.03967 5.89325 3.03967 4.29325 C 3.03967 2.65992 4.35967 1.33325 5.99967 1.33325 C 7.63301 1.33325 8.95967 2.65992 8.95967 4.29325 C 8.95301 5.89325 7.69301 7.19325 6.10634 7.24658 Z" />
              <path d="M 10.9402 2.66675 C 12.2335 2.66675 13.2735 3.71341 13.2735 5.00008 C 13.2735 6.26008 12.2735 7.28675 11.0268 7.33341 C 10.9735 7.32675 10.9135 7.32675 10.8535 7.33341" />
              <path d="M 2.77311 9.70675 C 1.15978 10.7867 1.15978 12.5467 2.77311 13.6201 C 4.60644 14.8467 7.61311 14.8467 9.44644 13.6201 C 11.0598 12.5401 11.0598 10.7801 9.44644 9.70675 C 7.61978 8.48675 4.61311 8.48675 2.77311 9.70675 Z" />
              <path d="M 12.2267 13.3333 C 12.7067 13.2333 13.16 13.0399 13.5334 12.7533 C 14.5734 11.9733 14.5734 10.6866 13.5334 9.90659 C 13.1667 9.62659 12.72 9.43992 12.2467 9.33325" />
            </svg>
          </div>
          <div className="toggle-label">Directory</div>
        </div>
        <div>
          <svg
            className={`chevron ${
              expandedSection === "directory" ? "" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </div>
      </div>
      {/* {expandedSection === "directory" && (
        <div className="sidebar-lists">
          <div className="section-title">Actions</div>
          <ul className="sidebar-sublist">
            <li>Register Incoming Mail</li>
            <li>Mail Approval</li>
          </ul>
          <div className="section-title">Standard Searches</div>
          <ul className="sidebar-sublist">
            <li>My mail received today</li>
            <li>My mail sent today</li>
            <li>My Outstanding & Overdue 
            mail</li>
            <li>Org mail not Closed Out</li>
            <li>Org mail received in last 30
            days</li>
            <li>Org Outstanding & Overdue
            mail</li>
            <li>RFIs received reports</li>
          </ul>
        </div>
      )} */}
    </div>
  );
};

export default Sidebar;
